require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-sentia-analytics-bs-react-motion.json") })
        }
      }, "path---package-unpublished-sentia-analytics-bs-react-motion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-sentia-analytics-bs-react-motion!./.cache/json/package-unpublished-sentia-analytics-bs-react-motion.json
// module id = 961
// module chunks = 231608221292675